import { VALUATION_PERSON_INPUT_CLASSIFIERS } from '@dealstack/shared/lib/common/business/valuationClassifiers';
import { SourcesUsesCategories } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/shared/SourcesUsesTable';
import { PersonInputFormValue } from '@dealstack/frontend/app/pages/Valuations/views/SourcesAndUses/types';

export const CATEGORY_TO_CLASSIFIER_MAP: Record<SourcesUsesCategories, string> = {
	[SourcesUsesCategories.Receivables]: VALUATION_PERSON_INPUT_CLASSIFIERS.RECEIVABLES,
	[SourcesUsesCategories.CashOnBalanceSheet]:
		VALUATION_PERSON_INPUT_CLASSIFIERS.CASH_ON_BALANCE_SHEET,
	[SourcesUsesCategories.Payables]: VALUATION_PERSON_INPUT_CLASSIFIERS.PAYABLES,
	[SourcesUsesCategories.RetainedCashAndHoldbacks]:
		VALUATION_PERSON_INPUT_CLASSIFIERS.RETAINED_CASH_AND_HOLDBACKS,
};

export interface PersonInputSavePayload {
	id?: string;
	categoryId: SourcesUsesCategories | string;
	value: PersonInputFormValue;
}
